<template>
  <div class="detail-padding">
    <div class="spaceBetween" style="margin-bottom:0.24rem">
      <div class="spaceLeft">
        <div class="detail-title-1">My proposal</div>
        <div class="spaceLeft start-vote" @click="toCreate">
          <img src="@/assets/image/governance/start-vote.png" />
          Initiate Proposal
        </div>
      </div>
      <div class="spaceLeft search-form">
        <!-- <search-select @valChange="valChange($event, 'status')" label="Proposal Status" :options="typeOptions" :default-value="searchParams.status" /> -->
        <!-- <search-select v-if="searchParams.status === '2'" @valChange="valChange($event, 'executeStatus')" label="Execution Status"
          :options="executedOptions" /> -->
        <div class="sapceLeft search-item">
          <el-input v-model="searchParams.id" placeholder="No..." suffix-icon="el-icon-search" @change="getList" />
        </div>
      </div>
    </div>

    <div class="common-card is-border">
      <div class="common-card-main">
        <el-table class="common-table" :data="tableList" v-loading="loading">
          <el-table-column prop="id" label="Proposal No.">
            <template slot-scope="{ row }">
              No.{{ row.id }}
            </template>
          </el-table-column>
          <el-table-column prop="title" label="Title" />
          <el-table-column prop="vote" label="Current Votes" align="right">
            <template slot-scope="{ row }">
              <big-number :number="row.totalWeight" />
              <span class="day">UNIT</span>
            </template>
          </el-table-column>
          <el-table-column prop="startBlock" label="Start Block" align="center" minWidth="140">
          </el-table-column>
          <el-table-column prop="" label="Duration" align="center">
            <template slot-scope="{ row }">
              <el-tooltip class="item" effect="dark" :content="duration.toString()" placement="top">
                <p class="duration">{{duration.toFixed(4)}} <span class="day">Day</span> </p>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="status" label="Proposal Status">
            <template slot-scope="{ row }">
              <vote-status-td-comp :status.sync="row.status" :over.sync="row.over" :cumulative.sync="row.vote"
                :threshold.sync="threshold" />
            </template>
          </el-table-column> -->
          <el-table-column prop="status" label="Proposal Status">
            <template slot-scope="{ row }">
              <!-- <span class="status ing" v-if="[0, 1].includes(row.status)">
                <img src="@/assets/image/governance/icon1.png" alt="">Ongoing
              </span>
              <span class="status passed" v-if="[4, 5, 7, 8].includes(row.status)">
                <img src="@/assets/image/governance/icon2.png" alt="">Passed
              </span>
              <span class="status failed" v-if="[2, 3, 6].includes(row.status)">
                <img src="@/assets/image/governance/icon3.png" alt="">Failed
              </span> -->
              <vote-status-td-comp :status.sync="row.status" />
            </template>
          </el-table-column>
          <el-table-column prop="executeStatus" label="Execution Status">
            <template slot-scope="{ row }"> 
              <span class="status" v-if="[1, 4, 5].includes(row.status)">
                <img src="@/assets/image/governance/icon8.png" alt="">Not executed
              </span>
              <span class="status" v-else-if="[2,3,6,7 ,8].includes(row.status)" >
                <img src="@/assets/image/governance/icon5.png" alt="">Executed
              </span>
              <span class="status" v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="Operation">
            <template slot-scope="{ row }">
              <el-button type="primary" @click="toDetail(row)">Details</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination :total.sync="queryParams.total" :page.sync="queryParams.page" :limit.sync="queryParams.pageSize"
          @pagination="getList()" />
      </div>
    </div>
    <extractDialog ref="extractDialog" @success="refresh" />
  </div>
</template>

<script>
import { proposalslist } from "@/api/dao.js"
import extractDialog from "./extractDialog.vue"
import voteStatusTdComp from "@/views/governance/components/voteStatusTdComp.vue"
export default {
  components: { extractDialog, voteStatusTdComp },
  data() {
    return {
      loading: false,
      duration: '',
      searchParams: {
        status: "0",
        id: undefined,
        executeStatus: undefined,

      },
      statusArr: [0, 1, 2, 3, 4, 5, 6, 7, 8],
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      tableList: [],
      typeOptions: this.$store.getters.proposalStatus,
      executedOptions: this.$store.getters.proposalExecutedStatus,
      threshold: 0,
    };
  },
  computed: {},
  methods: {
    async getThreshold(row) {
      try {
        row.curBlock = await web3.eth.getBlockNumber()
        row.threshold = await this.contractDao.methods.quorum(row.endBlock).call({ from: this.$store.getters.metaMaskObj.account })
        return row
      } catch (e) {
        console.log(e);
        row.threshold = 0
        return row
      }
    },
    async init() {
      if (this.getToken()) {
        this.contractDao = this.$store.getters.contractMap["contractDao"].contract;
        this.votingPeriod = await this.contractDao.methods.votingPeriod().call({from:this.$store.getters.metaMaskObj.account})
        this.duration = (this.votingPeriod *  5 / 86400)
        this.getList();
      } else {
        this.$message.warning("You must sign in to the wallet to view this page!");
      }
    },
    valChange(data, prop) {
      this.searchParams[prop] = data.value;
      if (data.value === '1') {
        this.statusArr = [0,1]
      } else if (data.value === '2') {
        this.statusArr = [4,5,7,8]
      } else if (data.value === '3') {
        this.statusArr = [2,3,6]
      } else if (data.value === '4') {
        this.statusArr = [5]
      } else if (data.value === '5') {
        this.statusArr = [4,7,8]
      } else {
        this.statusArr = [0, 1, 2, 3, 4, 5, 6, 7, 8]
      }
      this.getList();
    },
    getList() {
      if (!this.$store.getters.metaMaskObj.account) {
        return;
      }
      this.loading = true;
      proposalslist({
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
        proposer: this.$store.getters.metaMaskObj.account,
        id: this.searchParams.id,
        // status: this.statusArr,
        voter: this.$store.getters.metaMaskObj.account
      }).then(res => {
        let list = res.result && res.result.list || [];
        let reqArr = []
        list.forEach(item => {
          reqArr.push(this.getThreshold(item))
        })
        Promise.all(reqArr).then(() => {
          /*list.forEach(item => {
            if(item.curBlock >= item.endBlock) {
              if (item.totalWeight >= +item.threshold) {
                // pass
                 item.proposal_status = 4;
              }
              else {
                 // failed
                item.proposal_status = 2;
              }
            }
            else{
               // going
              item.proposal_status = 1;
            }
          })*/
          this.tableList = list
          this.queryParams.total = res.result.total || 0;
        })
        console.log("🚀 ~ file: index.vue:190 ~ getList ~ list:", list)
        this.loading = false;
      }).catch(e => {
        this.loading = false;
      })
    },
    extractDialog(data) {
      this.$refs.extractDialog.open({
        row: data
      })
    },
    toDetail(row) {
      this.$router.push({
        path: "/Governance/vote/Detail",
        query: {
          fromPath: "/Governance/proposal",
          proposalId: row.proposalId
        }
      });
    },
    toCreate() {
      if (this.getToken()) {
        this.$router.push("/Governance/vote/create")
      } else {
        this.$message.warning("You must sign in to the wallet to view this page!");
      }

    },
    refresh() {
      this.getList();
    }
  },
  created() {
    this.init();
  }
};
</script>
<style scoped lang="scss">
.blue-btn, .el-button--primary{
  background: linear-gradient(90deg, #0E3491 0%, #225BFC 100%);
}
.day{
  font-size: 0.12rem;
  color: rgba(255,255,255,0.5);
  transform: scale(0.75);
  display: inline-block;
}

.duration{
  color:#fff;
}
.start-vote {
  background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
  border-radius: 0.04rem;
  padding: 0.06rem 0.12rem;
  color: #fff;
  margin-left: 0.24rem;
  cursor: pointer;

  img {
    width: 0.16rem;
    margin-right: 0.12rem;
  }
}

.status {
  width: 1.12rem;
  height: 0.28rem;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 0.14rem;
  border-radius: 0.04rem;
  line-height: 0.28rem;
  white-space: nowrap;
  img {
    width: 0.24rem;
    margin-right: 0.06rem;
    margin-left: 0.1rem;
  }
}


</style>
